import createIcon from '../../createIcon';

/**
 * @component @name FilterListOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuNTQ1NSA3LjI5NTQ3SDIxLjcxNTVWNS4yOTU0N0g5LjU0NTQ3TDExLjU0NTUgNy4yOTU0N1pNMTYuNTQ1NSAxMi4yOTU1SDE4LjcxNTVWMTAuMjk1NUgxNC41NDU1TDE2LjU0NTUgMTIuMjk1NVpNMTQuNzE1NSAxNi4xMjU1VjE3LjI5NTVIMTAuNzE1NVYxNS4yOTU1SDEzLjg4NTVMMTAuODg1NSAxMi4yOTU1SDYuNzE1NDdWMTAuMjk1NUg4Ljg4NTQ3TDUuODg1NDcgNy4yOTU0N0gzLjcxNTQ3VjUuMjk1NDdIMy44ODU0N0wyLjEwNTQ3IDMuNTE1NDdMMy41MTU0NyAyLjEwNTQ3TDIxLjg5NTUgMjAuNDg1NUwyMC40ODU1IDIxLjg5NTVMMTQuNzE1NSAxNi4xMjU1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FilterListOff = createIcon('FilterListOff', [
  [
    'path',
    {
      d: 'M11.5455 7.29547H21.7155V5.29547H9.54547L11.5455 7.29547ZM16.5455 12.2955H18.7155V10.2955H14.5455L16.5455 12.2955ZM14.7155 16.1255V17.2955H10.7155V15.2955H13.8855L10.8855 12.2955H6.71547V10.2955H8.88547L5.88547 7.29547H3.71547V5.29547H3.88547L2.10547 3.51547L3.51547 2.10547L21.8955 20.4855L20.4855 21.8955L14.7155 16.1255Z',
      key: '16t2bl',
    },
  ],
]);

export default FilterListOff;
